/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvouchercode2Inputs */

const en_dropvouchercode2 = /** @type {(inputs: Dropvouchercode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const de_dropvouchercode2 = /** @type {(inputs: Dropvouchercode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Dropvouchercode2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvouchercode2 = /** @type {((inputs?: Dropvouchercode2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvouchercode2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvouchercode2(inputs)
	return de_dropvouchercode2(inputs)
});
export { dropvouchercode2 as "dropVoucherCode" }